import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { cn } from '../lib/cn.js';
/**
 * FilterPill — toggleable filter chip used in feed surfaces (Insights,
 * Signals, Alerts, Audit). Matches the prototype's `.filter-pill`:
 * mono caps, accent ring + soft accent fill when active, otherwise
 * subdued line + muted text.
 *
 * Click semantics: `onSelect` fires on click; the parent owns the
 * active state. Use `count` to hint how many items match the filter
 * (rendered as a trailing mono number).
 */
export function FilterPill({ active, onSelect, children, count, className, }) {
    return (_jsxs("button", { type: "button", onClick: onSelect, "aria-pressed": active, className: cn('inline-flex items-center gap-1.5 rounded-[var(--r-2,8px)] border px-2.5 py-1 font-mono text-[11px] uppercase tracking-[0.06em] transition-colors', active
            ? 'border-[var(--color-accent)] bg-[var(--color-accent-soft)] text-[var(--color-accent)]'
            : 'border-[var(--color-line-2)] bg-transparent text-[var(--color-ink-muted)] hover:border-[var(--color-line-strong)] hover:text-[var(--color-ink-secondary)]', className), children: [_jsx("span", { children: children }), count !== undefined && (_jsx("span", { className: cn('tabular-nums', active ? 'opacity-100' : 'opacity-70'), children: count }))] }));
}
